($ => {

    let picture1 = $('.DashPreview-picture1'),
        picture2 = $('.DashPreview-picture2'),
        picture3 = $('.DashPreview-picture3')

    $('.js-DashPreview-slide1').hover(function(ev) {
        picture1.removeClass('u-hidden')
        picture2.addClass('u-hidden')
        picture3.addClass('u-hidden')
    })

    $('.js-DashPreview-slide2').hover(function(ev) {
        picture1.addClass('u-hidden')
        picture2.removeClass('u-hidden')
        picture3.addClass('u-hidden')
    })

    $('.js-DashPreview-slide3').hover(function(ev) {
        picture1.addClass('u-hidden')
        picture2.addClass('u-hidden')
        picture3.removeClass('u-hidden')
    })

})(jQuery)